module.exports = __webpack_public_path__ + "static/bootstrap-theme-b47d14e5cedd762cc7deeea5d3422e57.png";